import React from "react";
import { IGiftFinderQuestionOption } from "@types";

interface Props {
    options: IGiftFinderQuestionOption[];
    value: any[];
    onChange: (value: any[]) => void;
}

const SingleSelection: React.FC<Props> = ({ options, value, onChange }) => {
    const selected = Array.isArray(value) ? value[0] : undefined;

    return (
        <div className="flex flex-col gap-3">
            {options.map((option) => {
                const isSelected = selected === option.id;
                return (
                    <button
                        key={option.id}
                        type="button"
                        aria-pressed={isSelected}
                        aria-label={`gift-finder-single-option-${option.id}`}
                        onClick={() => onChange([option.id])}
                        className={`w-full p-4 rounded-xl border flex items-center gap-3 transition-all duration-200 ${
                            isSelected
                                ? "border-button-primary bg-[#008AF60D]"
                                : "border-gray-200 hover:border-button-primary"
                        }`}
                    >
                        <span
                            className={`w-5 h-5 rounded-full border flex items-center justify-center ${
                                isSelected ? "border-button-primary" : "border-gray-300"
                            }`}
                        >
                            <span
                                className={`w-2.5 h-2.5 rounded-full ${
                                    isSelected ? "bg-button-primary" : "bg-transparent"
                                }`}
                            />
                        </span>
                        <span
                            className={`text-sm ${
                                isSelected ? "text-button-primary font-semibold" : "text-[#4F2F18]"
                            }`}
                        >
                            {option.option_data}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default React.memo(SingleSelection);
